/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */
 import PRM from "@/core/PermissionConstants";
 import  RouteConstants  from "@/app/core/RouteConstants";

export default {
  path: RouteConstants.OPTOMETRY_HISTORY.path,
  name: RouteConstants.OPTOMETRY_HISTORY.name,
  component: () => import("@/app/views/crud/CrudView.vue"),
  meta: {
    service: () => import("@/app/services/OptometryHistoryService"),
    table: () =>  import("@/app/components/optometry/history/OptometryHistoryTable"),
    form: () =>  import("@/app/components/optometry/history/OptometryHistoryForm"),
    header: {
      icono: "mdi-eye",
      texto: "Historial de consultas | Optometría",
      textNew: "Atender Consulta | Optometría",
      textEdit: "Editar Consulta | Optometría",
      textView: "Visualizar consulta | Optometría"
    },
     prm: PRM.MODULE_OPTOMETRY_HISTORY,
    requireAuth: true,
    filterDate: true,
    hideButtonAdd: true,
    filterModality: true,
    cancelationModal: true,
    generatePDFModal: true,
    labelDate: "Seleccione fecha",
    namePDF: "Optometría"
  },
};
